import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { cartMobx } from 'restaurant'
import './index.scss'

const TablePersonRemark: FC = () => {
  /** 桌码下才展示 */
  if (Config.codeType !== 'table') return null
  return (
    <div className='order-box'>
      <div className='order-box-info'>
        <p>{i18n.t('cart.person', { num: cartMobx.info.person })}</p>
        <p>{i18n.t('cart.remark')}{cartMobx.cartItems.map((item, index) => { return `${item.remark}${index !== cartMobx.cartItems.length - 1 && item.remark ? ';' : ''}` })}</p>
      </div>
    </div>
  )
}

export default observer(TablePersonRemark)
